/* src/app/refund-approve/refund-approve.component.css */
body {
  background-color: #f2f2f2;
  color: #000000;
}
.order_buttonicon {
  border-radius: 30px;
  background: #009f16 !important;
  text-transform: capitalize;
  box-shadow: none;
  padding: 0px 18px 0px 11px;
}
.order_buttonicon:hover {
  color: #fff !important;
  background-color: #009f16 !important;
}
.refund_textarea_body {
  background: none;
  border: none;
  resize: none;
  font-size: 13px;
  color: #000;
}
textarea {
  height: 72px;
  border-radius: 4px;
  border: 1px solid #cecece;
  margin-top: 4px;
  resize: none;
}
.input-ErrorField {
  font-size: 12px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #cc0000;
  background: transparent;
  position: relative;
  float: left;
}
.container-hide {
  visibility: hidden;
}
.container-unhide {
  visibility: visible;
}
.header_bg {
  background: url(/assets/images/ots_bg.png) no-repeat center top;
  text-align: center;
  background-size: cover;
}
.logo {
  text-align: left;
  color: #fff;
  padding: 12px 0px 0px 25px;
}
.user_main {
  float: right;
  text-align: right;
  color: white;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  padding: 30px 30px 30px 0px;
}
.user_main p {
  float: right;
  padding-right: 10px;
}
.user_icon {
  float: right;
  background-color: #008ad0;
  padding: 8px;
  border-radius: 30px;
  font-size: 20px;
}
.blw_headermain {
  text-align: left;
  color: #fff;
  padding: 10px 15px 0px 15px;
}
.blw_headermain img {
  float: left;
  padding-right: 10px;
}
.blw_headermain p {
  color: #2a2a2a;
  opacity: 0.8;
}
.refund_approve {
  float: left;
  color: black;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.round_table {
  border-radius: 20px;
  width: 100%;
  overflow-x: scroll;
  font-size: 12px;
}
.round_table {
  border-collapse: separate;
  border-spacing: 0;
}
.round_table tr {
  border: 1px solid #d6d6d6;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -o-border-radius: 20px;
  -webkit-border-radius: 10px;
}
.round_table td {
  border-bottom: 1px solid #d6d6d6;
  background-color: #ffffff;
}
.round_table tbody tr th:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:nth-child(1) {
  padding-left: 20px;
}
.round_table tbody tr td:last-child {
  width: 115px;
}
.transaction_main {
  margin-top: 10px;
}
.userbtn_main {
  float: right;
  padding: 10px 13px;
  margin: 0 10px;
  background-color: transparent;
  border-radius: 30px;
  margin-top: -70px;
  position: relative;
}
.download_report {
  background-color: #00adcc !important;
  padding: 8px 10px;
  border-radius: 20px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
  height: auto;
  line-height: unset;
  cursor: pointer;
}
.submit_btn {
  border-radius: 30px;
  background: #009f16;
  text-transform: capitalize;
  box-shadow: none;
  float: right;
  padding: 5px 20px;
}
.form-group {
  margin: 0px;
}
.download_report span {
  font-size: 20px;
  vertical-align: text-bottom;
}
.round_table tbody tr th {
  border-bottom: 1px solid #d6d6d6;
}
#exTab1 .tab-content {
  color: #000000;
  padding: 0px;
  background-color: #ffffff;
  clear: both;
}
#exTab1 .nav-pills > li > a {
  border-radius: 0;
}
td,
th {
  padding: 10px 5px;
  display: table-cell;
  text-align: left;
  vertical-align: middle;
  border-radius: 2px;
}
th,
td {
  vertical-align: middle;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nav_main {
  float: left;
  background-color: #ffffff;
  border-radius: 30px;
  border: 1px solid #cccccc;
  margin-bottom: 15px;
}
.btn:hover {
  background: transparent;
  color: #000;
}
.select_icon {
  background: transparent;
  color: #000000;
  border: 1px solid #01adcc;
  border-radius: 30px;
}
.dropdown-menu {
  right: 15px;
  left: auto;
  border-radius: 0px;
  padding: 0px;
  border: 1px solid #e4e4e4;
}
.dropdown-menu > li > a {
  display: block;
  padding: 15px 100px 15px 10px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
}
.drop_downicon {
  color: #ffffff;
  position: absolute;
  right: 13px;
  top: -24px;
  font-size: 30px;
}
.btn-primary.active,
.btn-primary:active,
.open > .dropdown-toggle.btn-primary {
  color: #000 !important;
  background-color: transparent !important;
  border-color: #01adcc !important;
}
p-dropdown {
  min-width: 130px !important;
  max-width: 140px !important;
}
textarea.form-control {
  min-width: 180px !important;
  max-width: 220px !important;
  width: 200px !important;
  resize: vertical;
  display: block;
}
@media (min-width: 300px) and (max-width: 600px) {
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #505050;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #b30000;
  }
  .logo {
    text-align: left;
    color: #fff;
    padding: 25px 14px 0px 25px;
  }
  .user_main {
    float: right;
    text-align: right;
    color: white;
    border-left: solid 1px rgba(0, 0, 0, 0.2);
    padding: 15px 28px 7px 0px;
    margin-left: 0px;
  }
  .blw_headermain img {
    float: left;
    padding-bottom: 25px;
    padding-right: 10px;
  }
  .buttons_main {
    padding-left: 0px;
  }
  .order_buttonicon {
    border-radius: 30px;
    background: #009f16 !important;
    text-transform: capitalize;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 8px 16px;
    height: auto;
    line-height: unset;
  }
  .refund_textarea_body {
    background: none;
    border: none;
    resize: none;
    font-size: 13px;
    color: #000;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
}
@media (max-width: 900px) and (min-width: 300px) {
  .userbtn_main {
    position: static;
    margin-top: 0px;
  }
}
@media (max-width: 900px) {
  p-dropdown,
  textarea.form-control {
    width: 100% !important;
    min-width: 120px !important;
    max-width: 100% !important;
  }
  td {
    min-width: 120px !important;
  }
}
.searchmain .search_modified {
  margin: 8px;
  background-color: #028ba3 !important;
  padding: 8px 10px;
  color: #ffffff;
  position: absolute;
  right: 0;
  height: 30px;
  box-sizing: border-box;
}
.searchmain .searchbox {
  width: 400px;
  display: inline-block;
  box-sizing: border-box;
  height: 30px;
  padding-right: 50px;
}
.searchmain .searchbox:focus {
  box-shadow: none;
}
.searchmain {
  margin: 3px;
  position: relative;
  text-align: right;
}
.transaction_btn {
  background-color: #028ba3 !important;
  padding: 9px 10px;
  border-radius: 20px;
  box-shadow: none !important;
  color: #ffffff !important;
  text-transform: capitalize;
}
.transaction_btn img {
  float: none;
  padding: 0px;
}
/*# sourceMappingURL=refund-approve.component.css.map */
